<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitUploadFile">
      <div class="form-group">
        <input type="file" @change="onFileChange" />
        <button @click="uploadFile">Загрузить</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "uploadPartnersFromExcel",
  data() {
    return {
      file: null
    };
  },
  methods: {
    submitUploadFile() {

    },
    onFileChange(e) {
      this.file = e.target.files[0];
    },
    async uploadFile() {
      const formData = new FormData();
      formData.append('file', this.file);
      alert('dddd');
      await axios
          .post('/v1/files/load-partners'
              , formData
              , {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          )
          .then(resp => {
            console.log(resp.data);
            alert('Файл загружен');
          })
          .catch(err => {
            console.log(err);
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    }
  }
};
</script>
